import { connect } from 'react-redux';
import { currentUserSelectors } from '@lifesize/nucleus';
import { DeleteChatModal } from 'components/DeleteChatModal/DeleteChatModal';
import actions from 'actions/FullScreenModal';
import { DELETE_CHAT_MODAL } from 'constants/Chat';
import { chatActions } from '@lifesize/nucleus';

const mapStateToProps = (state, ownProps) => {
  const currentUserInfo = currentUserSelectors.myInfo(state);
  return {
    currentUserInfo,
    chatDetails: ownProps
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    closeDeleteModal: () => {
      dispatch(actions.closeFullScreenModal(DELETE_CHAT_MODAL));
    },
    onDeleteChat: (contact) => dispatch(chatActions.deleteChat(contact))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteChatModal);
